import { useEffect, useRef, useState } from 'react';

const steps = [
  {
    number: '01',
    icon: 'ri-message-3-line',
    title: 'Você Entra em Contato',
    description: 'Entre em contato pelo WhatsApp ou formulário. Nossa equipe responde de forma imediata para ouvir seu caso.',
  },
  {
    number: '02',
    icon: 'ri-search-eye-line',
    title: 'Analisamos o Caso',
    description: 'Realizamos uma análise minuciosa da situação, coletando provas e avaliando as melhores possibilidades jurídicas.',
  },
  {
    number: '03',
    icon: 'ri-lightbulb-flash-line',
    title: 'Definimos a Estratégia',
    description: 'Elaboramos uma estratégia jurídica personalizada e eficaz, com foco total na recuperação do seu dinheiro ou conta.',
  },
  {
    number: '04',
    icon: 'ri-scales-3-line',
    title: 'Iniciamos a Ação',
    description: 'Colocamos o plano em prática com agilidade, mantendo você informado em cada etapa do processo até a resolução.',
  },
];

export default function HowItWorks() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="como-funciona" className="py-28 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-6">
        <div
          className="text-center mb-16"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'all 0.6s cubic-bezier(0.4,0,0.2,1)',
          }}
        >
          <span className="text-xs font-bold tracking-widest uppercase mb-3 inline-block" style={{ color: '#C9A24A' }}>
            Processo simples
          </span>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#0B2F5B' }}>
            Como <span style={{ color: '#C9A24A' }}>Funciona</span>
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#1A1A1A', opacity: 0.65 }}>
            Do primeiro contato à solução do seu caso, acompanhamos cada etapa com dedicação total.
          </p>
        </div>

        {/* Steps grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connector line - desktop only */}
          <div
            className="hidden lg:block absolute top-14 left-[12.5%] right-[12.5%] h-0.5 z-0"
            style={{ background: 'linear-gradient(to right, #C9A24A, #E1C67A, #C9A24A, #E1C67A)' }}
          />

          {steps.map((step, i) => (
            <div
              key={i}
              className="relative flex flex-col items-center text-center z-10"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(40px)',
                transition: `all 0.6s cubic-bezier(0.4,0,0.2,1) ${0.15 * i}s`,
              }}
            >
              {/* Number circle */}
              <div
                className="w-28 h-28 rounded-full flex flex-col items-center justify-center mb-6 relative"
                style={{ background: 'linear-gradient(135deg,#0B2F5B,#123E73)', boxShadow: '0 8px 24px rgba(11,47,91,0.25)' }}
              >
                <i className={`${step.icon} text-2xl mb-1`} style={{ color: '#C9A24A' }} />
                <span className="font-serif font-bold text-sm" style={{ color: '#E1C67A' }}>{step.number}</span>
              </div>

              <h3 className="font-bold text-lg mb-3 font-sans" style={{ color: '#0B2F5B' }}>
                {step.title}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: '#1A1A1A', opacity: 0.65 }}>
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
